import { render, staticRenderFns } from "./SupplierViewSupplierProducts.vue?vue&type=template&id=0dc6ed6f"
import script from "./SupplierViewSupplierProducts.vue?vue&type=script&lang=js"
export * from "./SupplierViewSupplierProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports